var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, unref as _unref, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-e8bc4eae"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "e-input-group__prepend"
};
var _hoisted_2 = {
    key: 1,
    class: "e-input-group__text-before"
};
var _hoisted_3 = { class: "flex items-center h-full shrink-0 text-gray-400" };
var _hoisted_4 = ["data-placeholder"];
var _hoisted_5 = ["id", "aria-label", "autocomplete", "data-maska", "disabled", "maxlength", "name", "placeholder", "readonly", "tabindex", "type", "value"];
var _hoisted_6 = { class: "e-input__suffix-inner flex items-center" };
var _hoisted_7 = {
    key: 2,
    class: "e-input__count"
};
var _hoisted_8 = { class: "e-input__count-inner" };
var _hoisted_9 = {
    key: 1,
    class: "e-input-group__text-after"
};
var _hoisted_10 = { class: "flex items-center h-full" };
var _hoisted_11 = {
    key: 2,
    class: "e-input-group__append"
};
var _hoisted_12 = { key: 3 };
var _hoisted_13 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "text-gray-400 text-xl" }, " * ", -1); });
var _hoisted_14 = [
    _hoisted_13
];
import { vMaska } from '@common/utils/libs/Maska';
import { computed, nextTick, ref, watch } from 'vue';
import EError from '@common/ui/EError/EError.vue';
import { z } from 'zod';
import EIcon from '@common/ui/EIcon.vue';
export default /*#__PURE__*/ _defineComponent(__assign({
    inheritAttrs: false,
}, { __name: 'EInput', props: /*#__PURE__*/ _mergeModels({
        name: {},
        theme: { default: 'default' },
        size: { default: 'medium' },
        type: { default: 'text' },
        id: {},
        disabled: { type: Boolean },
        readonly: { type: Boolean, default: false },
        placeholder: {},
        autocomplete: { type: Boolean },
        label: {},
        clearable: { type: Boolean, default: false },
        showWordLimit: { type: Boolean, default: false },
        tabindex: {},
        maxlength: {},
        keyFilter: {},
        inputCenter: { type: Boolean, default: false },
        mask: {},
        textBefore: {},
        textAfter: {},
        regexRule: {},
        required: { type: Boolean },
        hideError: { type: Boolean },
        position: {},
        rule: {},
        plugins: {}
    }, {
        "modelValue": { default: '' },
        "modelModifiers": {},
    }), emits: /*#__PURE__*/ _mergeModels(["input", "change", "inputValid", "changeValid", "clear", "blur", "focus", "paste"], ["update:modelValue"]), setup: function (__props, _a) {
        var _this = this;
        var __expose = _a.expose, __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var emailRule = z.string().email({ message: 'Невалидный email' });
        var inputRule = computed(function () {
            if (props.type === 'email' && !props.readonly) {
                var nonEmptyEmailRule = z.string().refine(function (value) { return value === '' || (emailRule === null || emailRule === void 0 ? void 0 : emailRule.safeParse(value).success); }, { message: 'Невалидный email' });
                if (props.rule) {
                    return props.rule.and(nonEmptyEmailRule);
                }
                return nonEmptyEmailRule;
            }
            return props.rule;
        });
        var valueModel = _useModel(__props, "modelValue");
        var inputRef = ref();
        var hovering = ref(false);
        var focused = ref(false);
        var isComposing = ref(false);
        var passwordVisible = ref(false);
        var isErrored = ref(false);
        var formattedValue = computed(function () {
            if (typeof valueModel.value !== 'string')
                return '';
            return valueModel.value;
        });
        var inputSize = computed(function () { return props.size; });
        var inputTheme = computed(function () { return props.theme; });
        var inputDisabled = computed(function () { return props.disabled; });
        var showClear = computed(function () {
            return props.clearable && !inputDisabled.value && !props.readonly && formattedValue.value && (focused.value || hovering.value);
        });
        var showPwdVisible = computed(function () {
            return props.type === 'password' && !inputDisabled.value && !props.readonly;
        });
        var isWordLimitVisible = computed(function () { return props.showWordLimit && props.maxlength && !inputDisabled.value && !props.readonly && props.type !== 'password'; });
        var upperLimit = computed(function () { return props.maxlength; });
        var textLength = computed(function () { return (valueModel.value || '').length; });
        var inputExceed = computed(function () { return isWordLimitVisible.value && textLength.value > upperLimit.value; });
        var localId = computed(function () { return props.id || props.name; });
        var isSuffixVisible = computed(function () { return showClear.value || props.type === 'password' || isWordLimitVisible.value; });
        var inputAutocomplete = computed(function () {
            return props.autocomplete ? 'on' : 'off';
        });
        var focus = function () {
            var _a;
            (_a = inputRef.value) === null || _a === void 0 ? void 0 : _a.focus();
        };
        var blur = function () {
            var _a;
            (_a = inputRef.value) === null || _a === void 0 ? void 0 : _a.blur();
        };
        watch(function () { return props.type; }, function (t) {
            if (t === 'password') {
                passwordVisible.value = true;
            }
        }, { immediate: true });
        var trimValue = function (event) {
            var target = event.target;
            var trimmedValue = target.value.trim();
            if (target.value !== trimmedValue) {
                emit('input', trimmedValue);
                emit('change', trimmedValue);
            }
        };
        var handleBlur = function (event) {
            var _a;
            focused.value = false;
            if ((_a = props.plugins) === null || _a === void 0 ? void 0 : _a.includes('trim')) {
                trimValue(event);
            }
            emit('blur', event);
        };
        var handleFocus = function (event) {
            focused.value = true;
            emit('focus', event);
        };
        var handleCompositionStart = function () {
            isComposing.value = true;
        };
        var handleCompositionUpdate = function () {
            isComposing.value = true;
        };
        var handleCompositionEnd = function (event) {
            if (isComposing.value) {
                isComposing.value = false;
                handleInput(event);
            }
        };
        var formattedInputValue = function (value) {
            var _a;
            return value.replace((_a = props.regexRule) !== null && _a !== void 0 ? _a : '', '');
        };
        var handleInput = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // я хз зачем
                        if (isComposing.value) {
                            return [2 /*return*/];
                        }
                        value = formattedInputValue(event.target.value || '');
                        valueModel.value = value;
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        emit('input', value);
                        if (!isErrored.value) {
                            emit('inputValid', value);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var handleChange = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        value = formattedInputValue(event.target.value || '');
                        valueModel.value = value;
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        emit('change', value);
                        if (!isErrored.value) {
                            emit('changeValid', value);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var clear = function () {
            emit('input', '');
            emit('change', '');
            emit('clear');
        };
        var handlePasswordVisible = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        passwordVisible.value = !passwordVisible.value;
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        focus();
                        return [2 /*return*/];
                }
            });
        }); };
        var handleKeypress = function (e) {
            if (typeof props.keyFilter === 'function') {
                return props.keyFilter(e);
            }
        };
        var handelPaste = function (e) {
            emit('paste', e);
        };
        __expose({
            inputRef: inputRef,
            focus: focus,
            blur: blur,
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(EError, {
                "hide-error": _ctx.hideError,
                name: _ctx.name,
                position: _ctx.position,
                rule: inputRule.value,
                value: valueModel.value,
                onChangeErrorStatus: _cache[4] || (_cache[4] = function ($event) { return (isErrored.value = $event); })
            }, {
                default: _withCtx(function () { return [
                    _createElementVNode("div", {
                        class: _normalizeClass([[
                                inputSize.value ? 'e-input--' + inputSize.value : '',
                                inputTheme.value ? 'e-input--' + inputTheme.value : '',
                                isErrored.value && 'e-input--error',
                                {
                                    'e-input--disabled': inputDisabled.value,
                                    'e-input--exceed': inputExceed.value,
                                    'e-input--input-center': _ctx.inputCenter,
                                    'e-input-group': _ctx.$slots.prepend || _ctx.$slots.append,
                                    'e-input-group--append': _ctx.$slots.append,
                                    'e-input-group--prepend': _ctx.$slots.prepend,
                                    'e-input-group--text-after': _ctx.textAfter,
                                    'e-input-group--text-before': _ctx.textBefore
                                }
                            ], "flex border rounded-lg e-input pr-2.5"]),
                        onMouseenter: _cache[2] || (_cache[2] = function ($event) { return (hovering.value = true); }),
                        onMouseleave: _cache[3] || (_cache[3] = function ($event) { return (hovering.value = false); })
                    }, [
                        (_ctx.$slots.prepend || _ctx.$slots.textBefore || _ctx.textBefore)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass([[
                                        !(_ctx.$slots.textBefore || _ctx.textBefore) && 'mr-2 '
                                    ], "e-input-group__pre-group"])
                            }, [
                                (_ctx.$slots.prepend)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                        _renderSlot(_ctx.$slots, "prepend")
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.$slots.textBefore || _ctx.textBefore)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                        _renderSlot(_ctx.$slots, "textBefore", {}, function () { return [
                                            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.textBefore), 1)
                                        ]; })
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 2))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", {
                            ref: "inputInnerWrapper",
                            "data-placeholder": _ctx.placeholder,
                            class: "e-input__inner-wrapper relative flex-grow flex flex-row items-center"
                        }, [
                            _withDirectives(_createElementVNode("input", _mergeProps(_ctx.$attrs, {
                                id: localId.value,
                                ref_key: "inputRef",
                                ref: inputRef,
                                "aria-label": _ctx.label,
                                autocomplete: inputAutocomplete.value,
                                "data-maska": _ctx.mask,
                                disabled: inputDisabled.value,
                                maxlength: _ctx.maxlength,
                                name: _ctx.name,
                                placeholder: _ctx.placeholder,
                                readonly: _ctx.readonly,
                                tabindex: _ctx.tabindex,
                                type: passwordVisible.value ? 'password' : 'text',
                                value: formattedValue.value,
                                class: "e-input__inner h-full w-full focus:outline-none transition-colors bg-transparent border-transparent appearance-none relative",
                                onBlur: handleBlur,
                                onChange: handleChange,
                                onCompositionend: handleCompositionEnd,
                                onCompositionstart: handleCompositionStart,
                                onCompositionupdate: handleCompositionUpdate,
                                onFocus: handleFocus,
                                onInput: handleInput,
                                onKeypress: handleKeypress,
                                onPaste: handelPaste
                            }), null, 16, _hoisted_5), [
                                [_unref(vMaska)]
                            ]),
                            (isSuffixVisible.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "e-input__suffix absolute inset-y-0 right-3 flex items-center h-full",
                                    onMousedown: _cache[1] || (_cache[1] = _withModifiers(function () { }, ["prevent"]))
                                }, [
                                    _createElementVNode("div", _hoisted_6, [
                                        (showClear.value)
                                            ? (_openBlock(), _createBlock(EIcon, {
                                                key: 0,
                                                class: "e-input__icon e-input__clear w-4 h-4 cursor-pointer",
                                                icon: "close",
                                                onClick: clear,
                                                onMousedown: _cache[0] || (_cache[0] = _withModifiers(function () { }, ["prevent"]))
                                            }))
                                            : _createCommentVNode("", true),
                                        (showPwdVisible.value)
                                            ? (_openBlock(), _createBlock(EIcon, {
                                                key: 1,
                                                icon: passwordVisible.value ? 'eye-linethrough' : 'eye',
                                                class: "e-input__icon e-input__password cursor-pointer w-4 h-4",
                                                onClick: handlePasswordVisible
                                            }, null, 8, ["icon"]))
                                            : _createCommentVNode("", true),
                                        (isWordLimitVisible.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                _createElementVNode("span", _hoisted_8, _toDisplayString(textLength.value) + "/" + _toDisplayString(upperLimit.value), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ], 32))
                                : _createCommentVNode("", true)
                        ], 8, _hoisted_4),
                        (_ctx.$slots.textAfter || _ctx.textAfter)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _renderSlot(_ctx.$slots, "textAfter", {}, function () { return [
                                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.textAfter), 1)
                                ]; })
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.$slots.append)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _renderSlot(_ctx.$slots, "append")
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.required)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                            : _createCommentVNode("", true)
                    ], 34)
                ]; }),
                _: 3
            }, 8, ["hide-error", "name", "position", "rule", "value"]));
        };
    } }));
